// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"V4-z","colorTextValue":"W4-z","swatches":"X4-z","collapseLink":"Y4-z","isCollapsed":"Z4-z","dropdown":"_4-z","disabled":"a5-z"};